export default __webpack_public_path__ + "static/media/facebook.1c873bb7.svg";